// https://rgxdb.com/r/3EZMSVWM
export const inputPattern = {
  email: /^[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)*@[-!#-'*+\/-9=?^-~]+(?:\.[-!#-'*+\/-9=?^-~]+)+$/i,
  postalCode: {
    'BE': /^(?:(?:[1-9])(?:\d{3}))$/, // Belgium
    'CH': /^[1-9]\d{3}$/, // Switzerland
    'DE': /^\d{5}$/, // Germany
    'DK': /^(?:[1-24-9]\d{3}|3[0-8]\d{2})$/, // Denmark
    'ES': /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/, // Spain
    'FR': /^(?:0[1-9]|[1-8]\d|9[0-8])\d{3}$/, // France
    'GB': /^([A-Z]{1,2}\d[A-Z\d]? ?\d[A-Z]{2}|GIR ?0A{2})$/, // United Kingdom
    'IT': /^\d{5}$/, // Italy
    'US': /^\d{5}(?:-\d{4})?$/, // United States
    'PT': /^\d{4}-\d{3}$/, // Portugal
    'PL': /^\d{2}-\d{3}$/, // Poland
    'RU': /^\d{6}$/, // Russia
    'NL': /^\d{4}\s?[A-Z]{2}$/, // Netherlands
    'HR': /^\d{5}$/ // Croatia
  },
  password: /(?=.*[a-zA-Z])((?=.*[0-9])|(?=.*([[:print:]][^[[:alnum:]]]))).{8,}/,
}
